var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 87,
    viewBox: "0 0 89 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5347_35",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 81,
    height: 79
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.215 33.1763C61.5813 42.7438 58.8137 55.5546 49.0299 61.7817C39.255 68.0087 26.1598 65.3103 19.7891 55.7428L25.8614 51.7536C29.9995 57.9633 38.5056 59.7233 44.8586 55.6736C51.2073 51.6303 53.0044 43.3103 48.8685 37.1006L55.2127 33.1784L55.215 33.1763Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3455 24.4001C62.9659 14.8368 49.8664 12.1514 40.0958 18.3936C30.3253 24.6379 27.5754 37.4487 33.955 47.0076L40.1378 43.1806C35.9953 36.9752 37.7814 28.6552 44.1256 24.6011C50.4765 20.5449 58.9804 22.2963 63.1273 28.5017L69.3477 24.4044L69.3455 24.4001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 39.2584C4 17.5784 21.9716 0 44.1432 0C66.3147 0 84.2797 17.5784 84.2797 39.2584C84.2797 60.9449 66.3125 78.5168 44.1432 78.5168C21.9782 78.5168 4.00663 60.9427 4.00663 39.2584H4ZM44.1432 75.7708C64.7629 75.7708 81.4745 59.4205 81.4745 39.2562C81.4745 19.0919 64.7585 2.74595 44.1387 2.74595C23.5234 2.74595 6.81179 19.0919 6.81179 39.2562C6.81179 59.4227 23.5234 75.7708 44.1387 75.7708H44.1432Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5347_35)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.5,
    cy: 40,
    rx: 52.5,
    ry: 49,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSec);
export default __webpack_public_path__ + "static/media/payment_sec.33f72d0d28f8755aad1765d7b90a9301.svg";
export { ForwardRef as ReactComponent };